<template>
  <div>
    <label for="bookingBrandSelected"
      >Brand<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="bookingBrandSelected"
      v-model="brand"
      :options="brands"
      label="text"
      track-by="id"
      :disabled="setDisable"
      style="margin: 0.6rem 0 0"
    >
    </multiselect>
  </div>
</template>

<script>
import BookingService from "services/api/booking.service";
import { assembleDropdown } from "@/utils/dropdown";
import { emitLoadingStart, emitLoadingDone } from "@/utils/loading";

export default {
  name: "BookingBrandDropdown",
  props: {
    value: { type: Object, default: null },
    setDisable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
  },
  data() {
    return {
      brand: this.value,
      brands: [],
    };
  },
  async created() {
    try {
      await this.getBrands();
    } catch (error) {
      console.log("Error during brand initialization:", error);
    }
  },
  watch: {
    brand(newValue) {
      this.$emit("setBrand", newValue);
    },
    value(newValue) {
      this.brand = newValue;
    },
    brands(newValue) {
      this.$emit("setBrands", newValue);
    },
  },
  methods: {
    async getBrands() {
      try {
        emitLoadingStart(this);
        await BookingService.getBrands()
          .then(async (res) => {
            this.brands = assembleDropdown(await res.data.items);
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
      emitLoadingDone(this);
    },
  },
};
</script>
